import { Section } from "./Section";
import { Reveal } from "./Reveal";

const PILLARS = [
    {
        n: "01",
        title: "Precision",
        text: "Measured, methodical work on every panel — nothing rushed, nothing approximate.",
    },
    {
        n: "02",
        title: "Craftsmanship",
        text: "Trained hands and honest materials, applied the way the car deserves.",
    },
    {
        n: "03",
        title: "Protection",
        text: "Every finish is built to be defended — against sun, salt, stone chips and time.",
    },
    {
        n: "04",
        title: "Process",
        text: "A defined path from inspection to reveal, so the result is repeatable, not lucky.",
    },
];

export const Difference = () => (
    <div className="rz-pattern">
        <Section id="difference" index="09" label="Philosophy" title="The difference is in the detail.">
            <div className="mt-14 grid grid-cols-1 border border-rz-steel/60 sm:grid-cols-2 lg:grid-cols-4">
                {PILLARS.map((p, i) => (
                    <Reveal
                        key={p.n}
                        delay={i * 0.07}
                        className={`group border-rz-steel/60 p-8 transition-colors duration-500 hover:bg-rz-graphite/50 lg:p-10 ${
                            i < PILLARS.length - 1 ? "border-b sm:border-b-0 lg:border-r" : ""
                        } ${i % 2 === 0 ? "sm:border-r" : ""} ${i < 2 ? "sm:border-b lg:border-b-0" : ""}`}
                    >
                        <span className="font-display text-[12px] font-semibold tracking-[0.25em] text-rz-red">
                            {p.n}
                        </span>
                        <h3 className="mt-4 font-display text-xl font-bold uppercase tracking-wide text-rz-white">
                            {p.title}
                        </h3>
                        <p className="mt-3 text-sm leading-relaxed text-rz-smoke">{p.text}</p>
                    </Reveal>
                ))}
            </div>
        </Section>
    </div>
);
